import { ISubmitResponse } from '@interfaces/models';
import { IOpenAccountState as _IOpenAccountState } from '@interfaces/state';
import { Action, createReducer, on } from '@ngrx/store';

import * as InternalTransferOpenAccountActions from '../../actions/open-account/internal-transfer-open-account.actions';
import * as OpenAccountActions from '../../actions/open-account/open-account.actions';
import * as SubmitMetricsActions from '../../actions/submit-metrics/submit-metrics.actions';

export interface IOpenAccountState extends _IOpenAccountState {}

export const initialState: IOpenAccountState = {
  openAccountResponse: {} as ISubmitResponse,
  submitMetricsProcessingId: '',
  settlementFundChoice: null,
};

const openAccountReducer = createReducer(
  initialState,
  on(OpenAccountActions.submitOpenAccountResponse, (state, prop) => {
    return {
      ...state,
      openAccountResponse: prop.payload,
    };
  }),
  on(
    InternalTransferOpenAccountActions.submitInternalTransferOpenAccountResponse,
    (state, prop) => {
      return {
        ...state,
        openAccountResponse: prop.payload,
      };
    },
  ),
  on(SubmitMetricsActions.submitMetricUpdateProcessingId, (state, prop) => {
    return {
      ...state,
      submitMetricsProcessingId: prop.payload.correlationId,
    };
  }),
  on(OpenAccountActions.updateSettlementFundChoice, (state, prop) => {
    return {
      ...state,
      settlementFundChoice: prop.payload,
    };
  }),
);

export function reducer(state: IOpenAccountState | undefined, action: Action) {
  return openAccountReducer(state, action);
}

export const getOpenAccountResponse = (state: IOpenAccountState) => state.openAccountResponse;

export const getSubmitMetricsID = (state: IOpenAccountState) => state.submitMetricsProcessingId;

export const getSettlementFundChoice = (state: IOpenAccountState) => state.settlementFundChoice;
